import React, { useState } from 'react';
import NewSupplyOrder from './NewSupplyOrder';
import SupplyOrders from './SupplyOrders';
import NewProducts from './NewProducts';

const Dashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'new-order' | 'orders' | 'new-products'>('new-order');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'new-order':
        return <NewSupplyOrder />;
      case 'orders':
        return <SupplyOrders />;
      case 'new-products':
        return <NewProducts />;
      default:
        return <NewSupplyOrder />;
    }
  };

  return (
    <div className="container-fluid">
      {/* Header */}
      <div className="row mb-4">
        <div className="col">
          <div className="dashboard-header rounded">
            <div className="container">
              <h2 className="mb-0">
                <i className="bi bi-boxes me-3"></i>
                Supplies Management Dashboard
              </h2>
              <p className="mb-0 opacity-75">Manage your supply orders and inventory</p>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="row mb-4">
        <div className="col">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <button 
                className={`nav-link ${activeTab === 'new-order' ? 'active' : ''}`}
                onClick={() => setActiveTab('new-order')}
              >
                <i className="bi bi-plus-circle me-2"></i>
                New Supply Order
              </button>
            </li>
            <li className="nav-item">
              <button 
                className={`nav-link ${activeTab === 'orders' ? 'active' : ''}`}
                onClick={() => setActiveTab('orders')}
              >
                <i className="bi bi-list-ul me-2"></i>
                Supply Orders
              </button>
            </li>
            <li className="nav-item">
              <button 
                className={`nav-link ${activeTab === 'new-products' ? 'active' : ''}`}
                onClick={() => setActiveTab('new-products')}
              >
                <i className="bi bi-box-seam me-2"></i>
                New Products
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Tab Content */}
      <div className="row">
        <div className="col">
          <div className="fade-in">
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
